import * as React from "react";
import { useRamps } from "../hooks/useRamps";
import { Ramp } from "../types";
import { RampsSkeleton } from "../screens/Ramps/RampsSkeleton";

// const RampStateContainerState = createContainer(useRampStateContainerState);
const RampsStateContainerState = React.createContext<{
  ramps: Ramp[];
  setRamps: (Ramps: Ramp[]) => void;
  isReference: boolean;
  ready?: boolean;
}>({
  ramps: [],
  setRamps: () => {},
  isReference: false,
  ready: false,
});

export const RampsStateContainer: React.FC<{
  children?: React.ReactNode;
  isReference: boolean;
  includeReferenceImage?: boolean;
}> = ({ children, isReference }) => {
  const { ready, ramps, setRamps } = useRamps(isReference, false);
  return (
    <RampsStateContainerState.Provider
      value={{
        ramps,
        setRamps,
        isReference,
        ready,
      }}
    >
      {ready ? children : <RampsSkeleton />}
    </RampsStateContainerState.Provider>
  );
};

/**
 * Hook into the current identity context.
 */
export const useRampsState = () => React.useContext(RampsStateContainerState);
